import { Environment, environment } from '@repo/environment';

import { roundToDecimalPlaces } from './decimal-utils';

export const bigIntWithDecimal = (num: number, decimal: number): bigint => {
  const roundedNum = roundToDecimalPlaces(num, decimal);
  const result = toFixedDigitsBigInt(roundedNum, decimal);

  // For local/dev/staging environments with 18 decimals, use larger divisor
  if ([Environment.LOCAL, Environment.DEVELOPMENT, Environment.STAGING].includes(environment)) {
    const divisor = BigInt('1000000000000000'); // 1 followed by 15 zeros
    return (result / divisor) * divisor;
  }

  // Production case (6 decimals) - default
  const divisor = BigInt(1000);
  return (result / divisor) * divisor;
};

const toFixedDigitsBigInt = (value: number, digits: number): bigint => {
  if (!Number.isFinite(value)) {
    throw new Error('Input must be a finite number');
  }

  // Convert to string to handle decimals precisely
  const [intPart, fracPart = ''] = value.toString().split('.');

  // Full number without decimal
  const fullNumber = intPart + fracPart;

  // Scale factor (how many digits we need to add after removing decimal)
  const scale = digits - fracPart.length;

  if (scale < 0) {
    throw new Error(`Number ${value} has more than ${digits} digits already`);
  }

  // Construct BigInt with padding zeros
  return BigInt(fullNumber + '0'.repeat(scale));
};
